import { useQuery } from '@tanstack/react-query';
import { runAlexandriaQuery } from './api';
import { Dashboard409MetricsCatalogDocument } from './generated/graphql';

const ONE_HOUR_MS = 60 * 60 * 1000;

export const useMetricsCatalog = () =>
  useQuery({
    queryKey: ['alexandria', 'metrics_catalog'],
    staleTime: ONE_HOUR_MS,
    queryFn: async () => {
      const data = await runAlexandriaQuery(Dashboard409MetricsCatalogDocument);
      return data.metrics_catalog;
    },
  });
